module.exports = __webpack_public_path__ + "img/login-bg-top.edd5900b.png";